var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 8.5L11.8853 13.7226C15.2834 15.648 16.7192 15.648 20.1173 13.7226L29.3346 8.5",
    stroke: "#0d6b70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.689 18.4668C2.77616 22.5543 2.81974 24.5979 4.32792 26.1119C5.83608 27.6257 7.93508 27.6784 12.1331 27.7839C14.7204 27.8489 17.2822 27.8489 19.8696 27.7839C24.0676 27.6784 26.1665 27.6257 27.6748 26.1119C29.1829 24.5979 29.2265 22.5543 29.3136 18.4668C29.3417 17.1525 29.3417 15.8461 29.3136 14.5319C29.2265 10.4445 29.1829 8.4008 27.6748 6.8869C26.1665 5.37299 24.0676 5.32026 19.8696 5.21478C17.2822 5.14976 14.7204 5.14976 12.1331 5.21476C7.93507 5.32023 5.83608 5.37296 4.3279 6.88688C2.81973 8.40079 2.77616 10.4445 2.68898 14.5319C2.66096 15.8461 2.66097 17.1525 2.689 18.4668Z",
    stroke: "#0d6b70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.a2c77529d8f4d1ebefe426ebb1796717.svg";
export { ForwardRef as ReactComponent };